export interface EpubViewerFontSizeState {
  readonly fontsize: number
  readonly disabled: boolean
}

export const initialEpubViewerFontSizeState: EpubViewerFontSizeState = {
  fontsize: 1,
  disabled: false,
};
